module.exports = __webpack_public_path__ + "img/img30.47e32e9a.svg";